import React from 'react';
import { parseISO, isAfter, isBefore } from 'date-fns';

import { AppData } from 'services/apollo/core';
import { ActivePropertyItem } from 'services/apollo/multisto';
import { useGetInvestorMetaValuesQuery } from 'services/apollo';

import PropertiesGrid from './components/PropertiesGrid';

interface FilterActivePropertiesProps {
  properties: ActivePropertyItem[];
  parameters: AppData;
}

const FilterActiveProperties: React.FC<FilterActivePropertiesProps> = ({ properties, parameters }) => {
  const { data: dataMeta, loading: metaLoading } = useGetInvestorMetaValuesQuery({
    fetchPolicy: 'no-cache',
  });

  if (metaLoading || !dataMeta?.investorMetaValues) {
    return <></>;
  }

  // the meta which uses for filter starts with "filter_"
  const metaKeys = dataMeta.investorMetaValues
    .filter((x) => x.key.slice(0, 7) === 'filter_' && !!x.value)
    .map((x) => ({
      value: x.value,
      key: x.key.slice(7),
    }));

  if (!metaKeys.length) {
    return <></>;
  }

  const filteredKey = metaKeys.filter((x) => x.key.slice(-5) !== '_sign');

  const filteredProperties: ActivePropertyItem[] = properties.filter((property) =>
    filteredKey.some(({ key, value }) => {
      const meta = property.meta.find((m) => m.key === key);
      if (!meta || !meta.value) {
        return false;
      }

      // checkbox
      if (value === 'true' && meta.value === 'true') {
        return true;
      }

      // sign is require
      const sign = metaKeys.find((x) => x.key === `${key}_sign`);
      if (!sign) {
        return false;
      }

      // date
      const investorDate = parseISO(value);
      const propertyDate = parseISO(meta.value);
      // check that dates are not invalid
      if (!Number.isNaN(investorDate.getDate()) && !Number.isNaN(propertyDate.getDate())) {
        if (sign.value === 'gt') {
          return isAfter(propertyDate, investorDate);
        }
        if (sign.value === 'lt') {
          return isBefore(propertyDate, investorDate);
        }
        return false;
      }

      // number
      const investorValue = parseInt(value, 10);
      const propertyValue = parseInt(meta.value, 10);
      if (!Number.isNaN(propertyValue) && !Number.isNaN(investorValue)) {
        if (sign.value === 'gt') {
          return propertyValue >= investorValue;
        }
        if (sign.value === 'lt') {
          return propertyValue <= investorValue;
        }
        return false;
      }

      return false;
    }),
  );

  return (
    <>
      <PropertiesGrid properties={filteredProperties} isFilter appData={parameters} />
      <br />
    </>
  );
};

export default FilterActiveProperties;
